// extracted by mini-css-extract-plugin
export default {"inputWrapper":"ResetPassword_inputWrapper__XS+Jl","version":"ResetPassword_version__0NleE","btn":"ResetPassword_btn__m0lCW"};